import Auth from '@aws-amplify/auth';

export const getJwtToken = (): Promise<string> =>
  Auth.currentSession()
    .then(session => session.getAccessToken())
    .then(accessToken => accessToken.getJwtToken());
